export default __webpack_public_path__ + "static/media/Defaults_tours.c2cb4418.png";